'use client'
import "./chunk-BAPDASTR.mjs";
import {
  PostHogTracker
} from "./chunk-KRN6J4YX.mjs";
import {
  ReactNativeTracker
} from "./chunk-E4HXNU6L.mjs";
import {
  WbkTracker
} from "./chunk-TDDYRI4K.mjs";
import {
  getAnalyticsUtms
} from "./chunk-67IEIQJX.mjs";
import "./chunk-PRBYVLPX.mjs";
import {
  useCookieConsent
} from "./chunk-X5SXWD3N.mjs";
import {
  context_default,
  useAnalytics_default
} from "./chunk-AL5LU2YW.mjs";
import {
  GtmTracker
} from "./chunk-PR2PUKCX.mjs";
import "./chunk-SSYZSLGO.mjs";
import "./chunk-4RITNUKZ.mjs";
import {
  CONSENT_COOKIE_NAME
} from "./chunk-T2NN7R53.mjs";
import {
  __async
} from "./chunk-BTG5EALA.mjs";

// src/context/provider.tsx
import { useEffect, useState } from "react";
import { getItem, readCookie, safeParseJson, setItem } from "@wbk/utils";
import { jsx } from "react/jsx-runtime";
var AnalyticsProvider = ({ children, trackers, currentLocation }) => {
  const [subscribers] = useState(
    () => trackers.concat(new ReactNativeTracker())
  );
  const [showConsent, setShowConsent] = useState(false);
  useEffect(() => {
    const utms = getAnalyticsUtms();
    if (utms) {
      setItem("utms", JSON.stringify(utms));
    }
  }, []);
  useEffect(() => {
    if (typeof navigator !== "undefined") {
      const savedWebview = readCookie("webview_mode");
      const isWebView = !!savedWebview || !!navigator.userAgent.match(/WBKWebView/i);
      for (const subscriber of subscribers) {
        subscriber.setDevice(isWebView ? "app" : "web");
      }
    }
  }, [subscribers]);
  useEffect(() => {
    if (currentLocation) {
      for (const subscriber of subscribers) {
        subscriber.pageView();
      }
    }
  }, [currentLocation]);
  useEffect(() => {
    const consent = getItem(CONSENT_COOKIE_NAME);
    if (!consent) {
      return setShowConsent(true);
    }
    const parsed = safeParseJson(consent);
    const EXPIRY_DURATION = 2 * 24 * 60 * 60 * 1e3;
    const isDenied = Object.values(parsed).some((v) => v === "denied");
    const isExpired = (/* @__PURE__ */ new Date()).getTime() - new Date(parsed.date).getTime() > EXPIRY_DURATION;
    setShowConsent(isDenied && isExpired);
  }, []);
  const setCookieConsent = (props) => {
    for (const subscriber of subscribers) {
      subscriber.setCookieConsent(props);
    }
    setShowConsent(false);
  };
  const pageView = () => {
    for (const subscriber of subscribers) {
      subscriber.pageView();
    }
  };
  const signupEvent = (props) => __async(void 0, null, function* () {
    for (const subscriber of subscribers) {
      subscriber.signupEvent(props);
      subscriber.setUser(props.user);
    }
  });
  const loginEvent = (props) => __async(void 0, null, function* () {
    for (const subscriber of subscribers) {
      subscriber.loginEvent(props);
      subscriber.setUser(props.user);
    }
  });
  const setUser = (props) => {
    for (const subscriber of subscribers) {
      subscriber.setUser(props);
    }
  };
  const viewItemEvent = (props) => __async(void 0, null, function* () {
    for (const subscriber of subscribers) {
      subscriber.viewItemEvent(props);
    }
  });
  const viewItemListEvent = (props) => {
    for (const subscriber of subscribers) {
      subscriber.viewItemListEvent(props);
    }
  };
  const registerInterestEvent = (props) => {
    for (const subscriber of subscribers) {
      subscriber.registerInterestEvent(props);
    }
  };
  const generateLeadEvent = (props) => {
    for (const subscriber of subscribers) {
      subscriber.generateLeadEvent(props);
    }
  };
  const viewItemBook = (props) => __async(void 0, null, function* () {
    for (const subscriber of subscribers) {
      subscriber.viewItemBook(props);
    }
  });
  const cartEvent = (props) => {
    for (const subscriber of subscribers) {
      subscriber.cartEvent(props);
    }
  };
  const viewSummaryEvent = (props) => {
    for (const subscriber of subscribers) {
      subscriber.viewSummaryEvent(props);
    }
  };
  const ticketsSummaryEvent = (props) => {
    for (const subscriber of subscribers) {
      subscriber.ticketsSummaryEvent(props);
    }
  };
  const paymentSummaryEvent = (props) => {
    for (const subscriber of subscribers) {
      subscriber.paymentSummaryEvent(props);
    }
  };
  const beginCheckout = (props) => {
    for (const subscriber of subscribers) {
      subscriber.beginCheckout(props);
    }
  };
  const purchaseEvent = (props) => __async(void 0, null, function* () {
    for (const subscriber of subscribers) {
      subscriber.purchaseEvent(props);
    }
  });
  const purchaseSubscriptionEvent = (props) => {
    for (const subscriber of subscribers) {
      subscriber.purchaseSubscriptionEvent(props);
    }
  };
  const purchaseFailed = () => {
    for (const subscriber of subscribers) {
      subscriber.purchaseFailed();
    }
  };
  const shareEvent = (props) => {
    for (const subscriber of subscribers) {
      subscriber.shareEvent(props);
    }
  };
  const newsletterEvent = (props) => {
    for (const subscriber of subscribers) {
      subscriber.newsletterEvent(props);
    }
  };
  const homePageFlightsTabClicked = ({
    user_status,
    active_bookings
  }) => {
    var _a;
    for (const subscriber of subscribers) {
      (_a = subscriber.homePageFlightsTabClicked) == null ? void 0 : _a.call(subscriber, { user_status, active_bookings });
    }
  };
  const flightsPageLoaded = () => {
    var _a;
    for (const subscriber of subscribers) {
      (_a = subscriber.flightsPageLoaded) == null ? void 0 : _a.call(subscriber);
    }
  };
  const flightsOriginSelected = (origin) => {
    var _a;
    for (const subscriber of subscribers) {
      (_a = subscriber.flightsOriginSelected) == null ? void 0 : _a.call(subscriber, origin);
    }
  };
  const flightsDestinationSelected = (destination) => {
    var _a;
    for (const subscriber of subscribers) {
      (_a = subscriber.flightsDestinationSelected) == null ? void 0 : _a.call(subscriber, destination);
    }
  };
  const flightsDepartureDateSelected = (departureDate) => {
    var _a;
    for (const subscriber of subscribers) {
      (_a = subscriber.flightsDepartureDateSelected) == null ? void 0 : _a.call(subscriber, departureDate);
    }
  };
  const flightsReturnDateSelected = (date) => {
    var _a;
    for (const subscriber of subscribers) {
      (_a = subscriber.flightsReturnDateSelected) == null ? void 0 : _a.call(subscriber, date);
    }
  };
  const flightsSearchStarted = (props) => {
    var _a;
    for (const subscriber of subscribers) {
      (_a = subscriber.flightsSearchStarted) == null ? void 0 : _a.call(subscriber, props);
    }
  };
  const flightsResultsLoaded = () => {
    var _a;
    for (const subscriber of subscribers) {
      (_a = subscriber.flightsResultsLoaded) == null ? void 0 : _a.call(subscriber);
    }
  };
  const flightsCardSelected = (props) => {
    var _a;
    for (const subscriber of subscribers) {
      (_a = subscriber.flightsCardSelected) == null ? void 0 : _a.call(subscriber, props);
    }
  };
  const flightsSortApplied = (sortBy) => {
    var _a;
    for (const subscriber of subscribers) {
      (_a = subscriber.flightsSortApplied) == null ? void 0 : _a.call(subscriber, sortBy);
    }
  };
  const flightsFilterApplied = (filter) => {
    var _a;
    for (const subscriber of subscribers) {
      (_a = subscriber.flightsFilterApplied) == null ? void 0 : _a.call(subscriber, filter);
    }
  };
  const flightsSummaryPageLoaded = (props) => {
    var _a;
    for (const subscriber of subscribers) {
      (_a = subscriber.flightsSummaryPageLoaded) == null ? void 0 : _a.call(subscriber, props);
    }
  };
  const flightsLoginPageLoaded = () => {
    var _a;
    for (const subscriber of subscribers) {
      (_a = subscriber.flightsLoginPageLoaded) == null ? void 0 : _a.call(subscriber);
    }
  };
  const flightsPassengersDetailsPageLoaded = (props) => {
    var _a;
    for (const subscriber of subscribers) {
      (_a = subscriber.flightsPassengersDetailsPageLoaded) == null ? void 0 : _a.call(subscriber, props);
    }
  };
  const flightsAddPassengerClicked = () => {
    var _a;
    for (const subscriber of subscribers) {
      (_a = subscriber.flightsAddPassengerClicked) == null ? void 0 : _a.call(subscriber);
    }
  };
  const flightsPassengerAdded = (props) => {
    var _a;
    for (const subscriber of subscribers) {
      (_a = subscriber.flightsPassengerAdded) == null ? void 0 : _a.call(subscriber, props);
    }
  };
  const flightsPassengerDetailsError = (props) => {
    var _a;
    for (const subscriber of subscribers) {
      (_a = subscriber.flightsPassengerDetailsError) == null ? void 0 : _a.call(subscriber, props);
    }
  };
  const flightPassengerDetailsContinueClicked = () => {
    var _a;
    for (const subscriber of subscribers) {
      (_a = subscriber.flightPassengerDetailsContinueClicked) == null ? void 0 : _a.call(subscriber);
    }
  };
  const flightsPaymentSummaryPageLoaded = () => {
    var _a;
    for (const subscriber of subscribers) {
      (_a = subscriber.flightsPaymentSummaryPageLoaded) == null ? void 0 : _a.call(subscriber);
    }
  };
  const flightsPaymentMethodSelected = (paymentMethod) => {
    var _a;
    for (const subscriber of subscribers) {
      (_a = subscriber.flightsPaymentMethodSelected) == null ? void 0 : _a.call(subscriber, paymentMethod);
    }
  };
  const flightProceedToPayment = (props) => {
    var _a;
    for (const subscriber of subscribers) {
      (_a = subscriber.flightProceedToPayment) == null ? void 0 : _a.call(subscriber, props);
    }
  };
  const flightsConfirmationPageLoaded = (props) => {
    var _a;
    for (const subscriber of subscribers) {
      (_a = subscriber.flightsConfirmationPageLoaded) == null ? void 0 : _a.call(subscriber, props);
    }
  };
  const flightsTabClicked = (activeBookings) => {
    var _a;
    for (const subscriber of subscribers) {
      (_a = subscriber.flightsTabClicked) == null ? void 0 : _a.call(subscriber, activeBookings);
    }
  };
  const flightBookingPageCardClicked = () => {
    var _a;
    for (const subscriber of subscribers) {
      (_a = subscriber.flightBookingPageCardClicked) == null ? void 0 : _a.call(subscriber);
    }
  };
  const flightsErrorOccurred = (props) => {
    var _a;
    for (const subscriber of subscribers) {
      (_a = subscriber.flightsErrorOccurred) == null ? void 0 : _a.call(subscriber, props);
    }
  };
  const trackEvent = (props) => {
    var _a;
    for (const subscriber of subscribers) {
      (_a = subscriber.trackEvent) == null ? void 0 : _a.call(subscriber, props);
    }
  };
  return /* @__PURE__ */ jsx(
    context_default.Provider,
    {
      value: {
        showConsent,
        setCookieConsent,
        signupEvent,
        loginEvent,
        setUser,
        viewItemEvent,
        viewItemListEvent,
        generateLeadEvent,
        viewItemBook,
        cartEvent,
        viewSummaryEvent,
        ticketsSummaryEvent,
        paymentSummaryEvent,
        beginCheckout,
        purchaseEvent,
        purchaseSubscriptionEvent,
        purchaseFailed,
        shareEvent,
        newsletterEvent,
        registerInterestEvent,
        pageView,
        trackEvent,
        homePageFlightsTabClicked,
        flightsPageLoaded,
        flightsOriginSelected,
        flightsDestinationSelected,
        flightsDepartureDateSelected,
        flightsReturnDateSelected,
        flightsSearchStarted,
        flightsResultsLoaded,
        flightsCardSelected,
        flightsSortApplied,
        flightsFilterApplied,
        flightsSummaryPageLoaded,
        flightsLoginPageLoaded,
        flightsPassengersDetailsPageLoaded,
        flightsAddPassengerClicked,
        flightsPassengerAdded,
        flightsPassengerDetailsError,
        flightPassengerDetailsContinueClicked,
        flightsPaymentSummaryPageLoaded,
        flightsPaymentMethodSelected,
        flightProceedToPayment,
        flightsConfirmationPageLoaded,
        flightsTabClicked,
        flightBookingPageCardClicked,
        flightsErrorOccurred
      },
      children
    }
  );
};
var provider_default = AnalyticsProvider;
export {
  provider_default as AnalyticsProvider,
  GtmTracker,
  PostHogTracker,
  WbkTracker,
  useAnalytics_default as useAnalytics,
  useCookieConsent
};
//# sourceMappingURL=index.mjs.map